import { FC, useRef } from 'react';
import { useEffect } from 'react';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';

export interface ProjectVideoProps {
  videoFile: {
    url: string;
    metadata?: {
      mimeType?: string;
    };
  };
}

export const PROJECT_ID = process.env.sanityProjectId;
export const DATASET = process.env.datasetEnvironment;

const ProjectVideo: FC<ProjectVideoProps> = ({ videoFile }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videojs(videoRef.current, {
        sources: [
          {
            src: videoFile.url,
            type: videoFile.metadata?.mimeType,
          },
        ],
      });
    }
  });

  return (
    <div className="h-[375px] tablet:h-[500px] laptop:h-[725px]">
      <div className="w-full h-full">
        <video
          controls
          ref={videoRef}
          className="video-js vjs-big-play-centered"
        />
      </div>
    </div>
  );
};

export default ProjectVideo;
